import React from 'react';

import Contract from './Contract';

const PrivacyPolicy = () => (

  <div className="boxed-container">
    <h2>
      User Information Notice
    </h2>

    <p>Because we care about your privacy, below you can find information about how we collect, process and use your personal data.</p>
    <Contract />
  </div>
);


export default PrivacyPolicy;
